let Environment = {
  Rain: "0x15f9dcC5a4DAB540e5831a6Bb059efEeCa95EB32",
  Vesting: "0x71B590b4492f4f1c4457B62ed639ffBCD53dF7Da",

  chinaTomi: "0xaDF3202480bD62F3dB150E27A0F811f999F253B9",
  leia: "0x3aEdC9075A8238A68BEc28495ea566f9abcA2840",
  GemsLocking: "0x6A1aa5ac35f38Bdb25BBD976E8eca942b23260b2",
  luckifyClaim: "0xca296A8eb84C612E7449890Df619b200160493a0",
  // GemsStaking: "0x03B830791ebb7c70C47936A57cDf02D13ff41168",
  GemsToken: "0x3010ccb5419F1EF26D40a7cd3F0d707a0fa127Dc",
  StackContact: "0xF5c9F83C14db63ab8260a8d19d0B3eC8B1903E92",
  // Doptoken: "0x3010ccb5419F1EF26D40a7cd3F0d707a0fa127Dc",
  StackcontactGems: "0x03B830791ebb7c70C47936A57cDf02D13ff41168",
  StackContactDop: "0x953be9C1ADb9c651bBEC52E614c06EEe7FF9AA27",
  TomiContract: "0x4385328cc4D643Ca98DfEA734360C0F596C83449",
  StackContractTomi: "0xEB3c2E183660D52B76f386ac5BD91dB3A4B3ED63",
  Api_Url: "https://dev-api-gems.quecko.org",
  nodeMinerSale: "0xbd074A0Cd91DBa50e892a863842501795BC59A99",
  AstroNovaGraph:
    "https://subgraph.satsuma-prod.com/323ce71d2cc0/usman--186639/astro-nova-live/api",
  NFAGraph:
    "https://api.studio.thegraph.com/query/63987/nfa-mainnet/version/latest",
  dop1: "0xF49e4197324059e819690a0588dec5AB25d3985C",
  dop: "0xec135D3aEe90a5119681Ce4317BA42281edA7b49",
  dopDynamic: "0xb9F0ACa7A19155ed63024Ce301336a191DB7062F",

  insurance: "0x21DA8afc2b24d8a9A126638b5f142Bf77a19CB59",
  minerInsurance: "0x86f9E6D7E3D159ec928b980d4146f65f6d77C3Dd",
  CreditRefund: "0x87a784a52EA5D49DC1C9400AD295ADA82Bd8B38E",

  AstraNovaRewards: "0xA54Ad53a5FeeBFC785d21a81F047aEb77a520cd9", // bonus contract

  USDT: "0x6fEA2f1b82aFC40030520a6C49B0d3b652A65915", //testnet
  TOMI: "0x84f0bC91f23649c76139d402a1c00c6aC19A4400", //testnet
  ETH: "0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE", //testnet
  USDC: "0x25762231808F040410586504fDF08Df259A2163c", //testnet
  WBTC: "0x54410d42628C7fD6720C489219033345Bcb7Cc73", //testnet
  GEMS: "0x7ddd14e3a173a5db7bb8fd74b82b667f221492b9", //testnet
  PEPE: "0x0592EBa69Aa5f2eF68d9cb740fBaB2c0c0CC6A91", //testnet
  LINK: "0x37bBd68526C9BDb49f18fB36983701E344f2A163", //testnet
  UNI: "0x079c46A5Ba477400a326E03Ad8D22FaBeaE57b4F", //testnet
  DOP: "0xa048E46C35cf210bB0d5bb46b2DD06828Ef17893", //testnet
  LEIA: "0x0592eba69aa5f2ef68d9cb740fbab2c0c0cc6a91", //testnet

  GemsStaking: "0x034f504F34330eA87dcc8aBae2935eac9fD2eFaE", //TESTNET
  GemsSubscription: "0xe7Ad3a7EC2fdc8aa141dB9AFc1f701AAb579DA85", //TESTNET

  GemsSubscriptionGraph:
    "https://api.studio.thegraph.com/query/75549/subscription-graph/version/latest", //TESTNET v1
  GemsSubscriptionGraph_v2:
    "https://api.studio.thegraph.com/query/80537/subscription-v2/version/latest", //TESTNET 2

  // GemsSubscription: "0xDd8B68ad2fF84C97F5198e9c5512171F1f779b42", //TESTNET

  GemsStakingGraph:
    "https://api.studio.thegraph.com/query/63987/staking-gems-testnet/12", //Test Net
  gems: "0x7ddd14e3a173a5db7bb8fd74b82b667f221492b9", //Test Net,

  PremiumNetRPC:
    "https://eth-sepolia.g.alchemy.com/v2/n_4iaIl35yi2Vc0AV3-eg9rsdbG95Tfg", //RPC  NET

  GemsSubscriptionGraphKey: "323ce71d2cc0",

  //GemsSubscriptionGraph: "https://api.studio.thegraph.com/query/75549/subscription-graph-v-1/version/latest", //New V1 Graph

  // GemsSubscriptionGraph_v2:"https://api.studio.thegraph.com/query/108663/subscription-graph-v-2/version/latest", // New V2 Graph

  // GemsSubscription: "0xDd8B68ad2fF84C97F5198e9c5512171F1f779b42", //TESTNET

  VestingRpc: "https://eth-sepolia.g.alchemy.com/v2/m1ZDZF0NDLbqkK-we12g0",
};
export default Environment;
